// Multivariate Dependencies
import React from 'react';
/**
 * @deprecated Do not use legacy components anymore.
 */
export var EzyVetImageIcon = function (_a) {
    var alt = _a.alt, icon = _a.icon;
    return (React.createElement("img", { alt: alt, className: 'imageIcon', height: 16, width: 16, src: "media/images/".concat(icon) }));
};
EzyVetImageIcon.defaultProps = {
    icon: 'cancel.png',
    alt: '',
};
//# sourceMappingURL=EzyVetImageIcon.js.map